import { Injectable } from '@angular/core';
import Fingerprint2 from 'fingerprintjs2';

@Injectable({
  providedIn: 'root'
})
export class FingerprintService {
  private _fingerprint: string;
  private options = {};

  public get fingerprint(): string {
    return this._fingerprint;
  }

  public set fingerprint(hash: string) {
    this._fingerprint = hash;
  }

  constructor() {}

  /**
   * Crée un hash unique à l'utilisateur en fonction de son navigateur
   */
  async setFingerprint(): Promise<boolean> {
    return await new Promise<boolean>(resolve => {
      try {
        Fingerprint2.get(this.options, components => {
          const parameters = components.map(component => component.value);
          const hash = Fingerprint2.x64hash128(parameters.join(''), 31);
          if (hash) this._fingerprint = hash;
          resolve(!!hash);
        });
      } catch (e) {
        // si erreur, l'utilisateur utilise une version IE trop daté, il est fou même IE 11 marche
        resolve(false);
      }
    });
  }
}
